import { Link } from 'react-router-dom';

const footerLinks = {
  products: {
    title: '产品系列',
    links: [
      { label: '工业级重型插接件', path: '/categories' },
      { label: '防振自锁插接件', path: '/categories' },
      { label: '高速数据插接件', path: '/categories' },
      { label: '防水户外插接件', path: '/categories' },
      { label: '微型精密插接件', path: '/categories' },
      { label: '模块化定制方案', path: '/categories' },
    ],
  },
  resources: {
    title: '资源中心',
    links: [
      { label: '技术文章', path: '/articles' },
      { label: '选型指南', path: '/articles' },
      { label: '维护保养', path: '/articles' },
      { label: '应用案例', path: '/articles' },
    ],
  },
  company: {
    title: '关于久久插',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '口碑见证', path: '/about' },
      { label: '联系我们', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-14 md:pt-18 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-plug-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-xl font-bold tracking-tight text-white">
                久久插
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-sm mb-5">
              久久插，专为追求持久稳固连接体验而设计的专业插接解决方案。工业级耐用品质，防松脱设计，让每一次插接都稳定持久，告别松动脱落烦恼。
            </p>
            <div className="flex items-center gap-3 flex-wrap">
              <a
                href="tel:400-888-9999"
                className="flex items-center gap-1.5 text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                400-888-9999
              </a>
              <span className="text-background-600">|</span>
              <a
                href="mailto:support@jiujiucha.com"
                className="flex items-center gap-1.5 text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line"></i>
                support@jiujiucha.com
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <a href="/categories" className="hover:text-primary-400 transition-colors">{footerLinks.products.title}</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.products.links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <a href="/articles" className="hover:text-primary-400 transition-colors">{footerLinks.resources.title}</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.resources.links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">
              <a href="/about" className="hover:text-primary-400 transition-colors">{footerLinks.company.title}</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.company.links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 久久插 版权所有 | 持久稳固连接解决方案
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span>选择久久插，品质保障有口皆碑</span>
          </div>
        </div>
      </div>
    </footer>
  );
}